// onMarsReference.ts
export type ReferenceEntry = {
  id: string;
  category: "resource" | "unit" | "location" | "system" | "card" | "timing" | "scoring";
  title: string;
  short: string;
  details: string[];
  tags: string[];
};

export const onMarsReference: ReferenceEntry[] = [
  {
    "id": "ref-water",
    "category": "resource",
    "title": "Woda",
    "short": "Podstawowy zasób wykorzystywany przy budowie i efektach.",
    "details": [
      "Przechowuj ją w magazynie osobistym.",
      "Nie przekraczaj limitu magazynu."
    ],
    "tags": [
      "woda",
      "zasób"
    ]
  },
  {
    "id": "ref-plant",
    "category": "resource",
    "title": "Roślina",
    "short": "Zasób powiązany ze szklarniami i kontraktami.",
    "details": [
      "Może być wydawana przy budowie i efektach kart."
    ],
    "tags": [
      "roślina",
      "zasób"
    ]
  },
  {
    "id": "ref-oxygen",
    "category": "resource",
    "title": "Tlen",
    "short": "Zasób powiązany z rozwojem LSS.",
    "details": [
      "Może być kosztem akcji lub premią z technologii."
    ],
    "tags": [
      "tlen",
      "LSS"
    ]
  },
  {
    "id": "ref-energy",
    "category": "resource",
    "title": "Energia",
    "short": "Zasób produkowany przez generatory.",
    "details": [
      "Jest potrzebna przy części budów i efektów."
    ],
    "tags": [
      "energia",
      "generator"
    ]
  },
  {
    "id": "ref-mineral",
    "category": "resource",
    "title": "Minerał",
    "short": "Elastyczny zasób budowlany.",
    "details": [
      "Nie zastępuje dowolnego zasobu przy realizacji kontraktów."
    ],
    "tags": [
      "minerał",
      "kopalnia"
    ]
  },
  {
    "id": "ref-crystal",
    "category": "resource",
    "title": "Kryształ",
    "short": "Waluta używana m.in. do akcji wykonawczych.",
    "details": [
      "Nowy kryształ staje się dostępny dopiero na początku następnej tury."
    ],
    "tags": [
      "kryształ",
      "waluta"
    ]
  },
  {
    "id": "ref-colonist",
    "category": "unit",
    "title": "Kolonista",
    "short": "Pracownik wykorzystywany do akcji.",
    "details": [
      "Dostępni koloniści są w kwaterach.",
      "Koloniści na polach nie wracają automatycznie."
    ],
    "tags": [
      "kolonista",
      "pracownik"
    ]
  },
  {
    "id": "ref-bot",
    "category": "unit",
    "title": "Bot",
    "short": "Jednostka wyznaczająca strefę budowy.",
    "details": [
      "Budowa i ulepszanie wymagają zasięgu własnego bota.",
      "Łazik nie zastępuje bota."
    ],
    "tags": [
      "bot",
      "budowa"
    ]
  },
  {
    "id": "ref-rover",
    "category": "unit",
    "title": "Łazik",
    "short": "Jednostka eksploracyjna.",
    "details": [
      "Zbiera kryształy, badania i odkrycia.",
      "Nie zapewnia zasięgu budowy."
    ],
    "tags": [
      "łazik",
      "eksploracja"
    ]
  },
  {
    "id": "ref-scientist",
    "category": "unit",
    "title": "Naukowiec",
    "short": "Specjalista współpracujący z budynkami zaawansowanymi.",
    "details": [
      "Może udostępniać akcję wykonawczą.",
      "Punktuje za pasujące budynki."
    ],
    "tags": [
      "naukowiec",
      "budynek zaawansowany"
    ]
  },
  {
    "id": "ref-orbit",
    "category": "location",
    "title": "Orbita",
    "short": "Strefa technologii, projektów i zaopatrzenia.",
    "details": [
      "Akcje główne zależą od strony, po której znajduje się gracz."
    ],
    "tags": [
      "orbita",
      "strefa"
    ]
  },
  {
    "id": "ref-mars",
    "category": "location",
    "title": "Mars",
    "short": "Strefa budowy, ulepszania i eksploracji.",
    "details": [
      "Tu rozwijasz większość systemów kolonii."
    ],
    "tags": [
      "Mars",
      "strefa"
    ]
  },
  {
    "id": "ref-storage",
    "category": "system",
    "title": "Magazyn osobisty",
    "short": "Miejsce przechowywania zasobów i kryształów.",
    "details": [
      "Pojemność jest ograniczona.",
      "Świeże kryształy przechowuj oddzielnie."
    ],
    "tags": [
      "magazyn",
      "limit"
    ]
  },
  {
    "id": "ref-orbital-warehouse",
    "category": "location",
    "title": "Magazyn orbitalny",
    "short": "Wspólna oferta zasobów.",
    "details": [
      "Zawartość maleje w trakcie gry.",
      "Uzupełnianie następuje w określonych momentach rozwoju kolonii."
    ],
    "tags": [
      "magazyn orbitalny",
      "zaopatrzenie"
    ]
  },
  {
    "id": "ref-lss",
    "category": "system",
    "title": "LSS",
    "short": "System podtrzymywania życia kolonii.",
    "details": [
      "Rozwija się przez budowę właściwych budynków.",
      "Wpływa na poziom kolonii."
    ],
    "tags": [
      "LSS",
      "kolonia"
    ]
  },
  {
    "id": "ref-colony-level",
    "category": "system",
    "title": "Poziom kolonii",
    "short": "Wspólny poziom rozwoju Marsa.",
    "details": [
      "Zmienia technologie, magazyn, projekty i działanie wahadłowca.",
      "Może przybliżać koniec gry."
    ],
    "tags": [
      "poziom kolonii",
      "rozwój"
    ]
  },
  {
    "id": "ref-complex",
    "category": "system",
    "title": "Kompleks",
    "short": "Połączona grupa budynków tego samego typu.",
    "details": [
      "Tworzenie i powiększanie może wymagać technologii."
    ],
    "tags": [
      "kompleks",
      "budynki"
    ]
  },
  {
    "id": "ref-technology",
    "category": "system",
    "title": "Technologia",
    "short": "Trwałe ulepszenie gracza.",
    "details": [
      "Może być używana przez innych graczy za premię dla właściciela.",
      "Poziom ogranicza niektóre działania."
    ],
    "tags": [
      "technologia",
      "poziom"
    ]
  },
  {
    "id": "ref-project",
    "category": "card",
    "title": "Projekt",
    "short": "Karta pozwalająca zbudować budynek zaawansowany.",
    "details": [
      "Daje premię po pozyskaniu.",
      "Niezbudowany może dać punkty ujemne."
    ],
    "tags": [
      "projekt",
      "karta"
    ]
  },
  {
    "id": "ref-advanced-building",
    "category": "system",
    "title": "Budynek zaawansowany",
    "short": "Ulepszony budynek powstały dzięki projektowi.",
    "details": [
      "Może udostępniać akcję wykonawczą.",
      "Współpracuje z naukowcem."
    ],
    "tags": [
      "budynek zaawansowany",
      "ulepszenie"
    ]
  },
  {
    "id": "ref-contract",
    "category": "card",
    "title": "Kontrakt ziemski",
    "short": "Zobowiązanie punktujące dodatnio lub ujemnie.",
    "details": [
      "Elementów odłożonych na kontrakt nie można odzyskać."
    ],
    "tags": [
      "kontrakt",
      "punktacja"
    ]
  },
  {
    "id": "ref-private-goal",
    "category": "card",
    "title": "Cel prywatny",
    "short": "Tajny warunek dający nagrodę.",
    "details": [
      "W całej grze realizujesz maksymalnie jeden."
    ],
    "tags": [
      "cel prywatny"
    ]
  },
  {
    "id": "ref-mission",
    "category": "card",
    "title": "Misja",
    "short": "Wspólny cel wpływający na tempo gry.",
    "details": [
      "Wkład może dawać kryształy.",
      "Ukończenie wymaganej liczby uruchamia koniec gry."
    ],
    "tags": [
      "misja",
      "koniec gry"
    ]
  },
  {
    "id": "ref-shuttle",
    "category": "system",
    "title": "Wahadłowiec",
    "short": "Wspólny transport między Orbitą i Marsem.",
    "details": [
      "Poziom kolonii wpływa na jego ruch."
    ],
    "tags": [
      "wahadłowiec",
      "podróż"
    ]
  },
  {
    "id": "ref-private-ship",
    "category": "system",
    "title": "Prywatny statek",
    "short": "Własny transport gracza.",
    "details": [
      "Pozwala podróżować niezależnie od wahadłowca.",
      "Może punktować na końcu gry."
    ],
    "tags": [
      "statek",
      "podróż"
    ]
  },
  {
    "id": "ref-main-action",
    "category": "timing",
    "title": "Akcja główna",
    "short": "Podstawowa akcja wykonywana raz w turze.",
    "details": [
      "Dostępność zależy od aktualnej strefy."
    ],
    "tags": [
      "akcja główna",
      "tura"
    ]
  },
  {
    "id": "ref-executive-action",
    "category": "timing",
    "title": "Akcja wykonawcza",
    "short": "Dodatkowa akcja wykonywana maksymalnie raz w turze.",
    "details": [
      "Może być przed albo po akcji głównej.",
      "Zwykle wymaga kryształu lub naukowca."
    ],
    "tags": [
      "akcja wykonawcza",
      "tura"
    ]
  },
  {
    "id": "ref-construction",
    "category": "system",
    "title": "Budowa",
    "short": "Umieszczenie podstawowego budynku na mapie.",
    "details": [
      "Wymaga zasięgu bota.",
      "Po budowie LSS sprawdź poziom kolonii."
    ],
    "tags": [
      "budowa",
      "Mars"
    ]
  },
  {
    "id": "ref-upgrade",
    "category": "system",
    "title": "Ulepszenie",
    "short": "Przekształcenie budynku podstawowego w zaawansowany.",
    "details": [
      "Wymaga projektu i legalnego budynku."
    ],
    "tags": [
      "ulepszenie",
      "projekt"
    ]
  },
  {
    "id": "ref-end-trigger",
    "category": "timing",
    "title": "Uruchomienie końca gry",
    "short": "Początek finałowej sekwencji.",
    "details": [
      "Dokończ bieżącą rundę.",
      "Rozegraj jeszcze jedną rundę bez końcowej fazy wahadłowca."
    ],
    "tags": [
      "koniec gry"
    ]
  },
  {
    "id": "ref-end-scoring",
    "category": "scoring",
    "title": "Punktacja końcowa",
    "short": "Końcowe podliczenie wszystkich źródeł OP.",
    "details": [
      "Punktuj postęp, technologie, statki, projekty, kolonistów, naukowców i kontrakty."
    ],
    "tags": [
      "punktacja",
      "OP"
    ]
  }
];

export const onMarsReferenceById = Object.fromEntries(
  onMarsReference.map((entry) => [entry.id, entry]),
) as Record<string, ReferenceEntry>;

export function searchOnMarsReference(query: string): ReferenceEntry[] {
  const q = query.trim().toLocaleLowerCase("pl-PL");
  if (!q) return onMarsReference;
  return onMarsReference.filter((entry) =>
    [entry.title, entry.short, ...entry.details, ...entry.tags]
      .join(" ")
      .toLocaleLowerCase("pl-PL")
      .includes(q),
  );
}
